import React, { useContext, useState, useEffect, useRef } from "react";

import { QueryParamsContext } from "../../context/QueryParamsContext";
import { find } from "../../repositories/qerpapi/erp/RouteRepository";

import SelectErp from "../basics/SelectErp";

let typingTimer = null;

const SearchSelect = ({
  label = "",
  value,
  variant = "standard",
  setValue,
  error,
  helperText,
  filter = "",
  filterTranslate = "",
  route = "",
  include = "",
  descriptionField = "descricao",
  disabled = false,
  onChange = (e) => {
    setValue(e);
  },
  getOptionLabel,
  fields,
  where = {},
  customChange = false,
  rawUrl = null,
  urlFilters = "",
  disabledTextSearch = true,
  handleRequestArray = null,
  ...props
}) => {
  const [text, setText] = useState("");
  const [optionsList, setOptionsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { queryParams } = useContext(QueryParamsContext);
  const inputRef = useRef();
  const handleSearchText = (e) => {
    setText(e.target.value);
  };

  const generateMappedValues = (columns, value, shouldEncode = false) => {
    return columns.split(",").reduce((result, column) => {
      result[column] = shouldEncode
        ? encodeURIComponent(`${value}`)
        : `${value}`;
      return result;
    }, {});
  };

  useEffect(() => {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      try {
        setLoading(true);

        if (!filter || !text) {
          return;
        }

        const callback = await find({
          empresaCnpj: queryParams.empresa_cnpj,
          path: route,
          include,
          orWhere: generateMappedValues(filter, text, true),
          orWhereTranslate: generateMappedValues(filterTranslate, text, true),
          fields,
          where,
          rawUrl,
          urlObjects: generateMappedValues(urlFilters, text),
        });

        if (callback && callback.success) {
          const resultRequest = handleRequestArray
            ? handleRequestArray(callback.data)
            : callback.data;
          setOptionsList(resultRequest);
          if (resultRequest.length === 1 && !customChange) {
            setValue(resultRequest[0]);
            inputRef.current.blur();
          }
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }, 1200);
  }, [text, queryParams.empresa_cnpj, route, include, customChange]); // eslint-disable-line

  return (
    <SelectErp
      disabledSearchByText={disabledTextSearch}
      inputRef={inputRef}
      variant={variant}
      label={label}
      value={value}
      setValue={setValue}
      disabled={disabled}
      optionsList={optionsList}
      getOptionLabel={getOptionLabel}
      error={error}
      onChangeText={handleSearchText}
      onChange={(e) => {
        onChange(e);
      }}
      loading={loading}
      helperText={helperText}
      descriptionField={descriptionField}
      {...props}
    />
  );
};

export default SearchSelect;
